export const formatAmount = (value) => {
    const val = value.toString()
    const splittedVal = val.split('.')
    const wholeNumber = splittedVal[0].split('').reverse()
    const decimal = splittedVal[1]
    let len = wholeNumber.length
    const formattedValArray = []
    for (let i = 0; i < len; i += 1) {
        if (i % 3 === 0 && i !== 0) {
            Array.prototype.push.apply(formattedValArray, [',', wholeNumber[i]])
        } else {
            formattedValArray.push(wholeNumber[i])
        }
    }
    const formattedVal = formattedValArray.reverse().join('')
    if (val % 1 !== 0) {
        return formattedVal + '.' + decimal
    } else {
        return formattedVal
    }
}

